import { SiteHeader as SiteHeaderComponent, SiteHeaderIconButton } from "@xapp/components";
import { UserProfile } from "auth/modules/state";
import { AppSwitcherContainer } from "components/AppSwitcher";
import { NavDrawer } from "components/NavDrawer";
import { OrgSwitcherContainer } from "components/OrgSwitcher";
import { App, useGetOrgsQuery } from "generated/graphql";
import React, { FC, useEffect, useState, PropsWithChildren } from "react";
import style from "./style.scss";
import { setTimesSeen } from "./utils";

export type SiteHeaderApp = Pick<App, "name" | "organizationId" | "appId">;

export interface SiteHeaderProps {
    readonly asUser?: boolean;
    readonly user: UserProfile;
    onChangePerspective(): void;
}

export const SiteHeader: FC<PropsWithChildren<SiteHeaderProps>> = props => {
    const { asUser } = props;

    const [showNavDrawer, setShowNavDrawer] = useState<boolean>(false);

    const [getOrgs] = useGetOrgsQuery({
        requestPolicy: "cache-and-network",
        variables: {
            from: 0,
            size: 12
        }
    });

    const { data } = getOrgs;

    // If they only have one org, don't display it
    const totalOrgs = data?.orgs?.total;

    useEffect(setTimesSeen, []);

    function handleToggleNavDrawer() {
        setShowNavDrawer(val => !val);
    }

    function renderAsUserNotice() {
        if (asUser) {
            return (
                <p className={style.asUserNotice}>
                    You are viewing this page as a user.{" "}
                    <button onClick={props.onChangePerspective}>
                        Click here
                    </button>{" "}
                    to return to the Admin view
                </p>
            );
        }
    }

    return (
        <>
            <SiteHeaderComponent>
                <SiteHeaderIconButton icon="menu" onClick={handleToggleNavDrawer} />
                <div className={style.contentWrap}>
                    <div className={style.orgSwitcher}>
                        {totalOrgs > 1 ? <OrgSwitcherContainer /> : <></>}
                    </div>
                    <div className={style.appSwitcher}>
                        <AppSwitcherContainer />
                    </div>
                </div>

                <div className={style.headerNav}>
                    {props.children}
                </div>
            </SiteHeaderComponent>

            {renderAsUserNotice()}

            {/* Only render the NavDrawer if we have a user profile & orgs */}
            {// only render the Nav Drawer if there is a user profile in state
                props.user && (
                    <NavDrawer isActive={showNavDrawer} onToggleClick={handleToggleNavDrawer} organizations={getOrgs?.data?.orgs?.orgs} />
                )
            }
        </>
    );

};
